import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import * as S from './SidebarLink.style';

const SidebarLink = ({
  onClick,
  isDesktop,
  path,
  disabled,
  Icon,
  name,
  expanded,
}) => {
  const translatedName = i18n.t(
    `sidebar.${name?.replaceAll(' ', '-').toLowerCase()}`
  );

  return (
    <S.MenuItem
      onClick={onClick}
      to={path}
      disabled={disabled}
      className="anchor-element"
      data-tooltip-id="sidebar-tooltip"
      data-tooltip-content={translatedName}
      $expanded={expanded}
    >
      <S.IconWrapper>
        <Icon color="currentColor" width={24} height={24} />
      </S.IconWrapper>
      {(expanded || !isDesktop) && <S.Label>{translatedName}</S.Label>}
    </S.MenuItem>
  );
};

SidebarLink.propTypes = {
  onClick: PropTypes.func,
  Icon: PropTypes.func,
  name: PropTypes.string,
  path: PropTypes.string,
  isDesktop: PropTypes.bool,
  expanded: PropTypes.bool,
  disabled: PropTypes.bool,
};

SidebarLink.defaultProps = {
  expanded: true,
};

export default SidebarLink;
